import React from "react";

const CustomerRulesAndRegulations = (props) => {
  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h3 className="title_text text-dark">
                  Customer Account Milestone Policy
                </h3>

                <p className="info_description text-dark opacity-75 mb-3">
                  To ensure fairness, transparency, and the integrity of the
                  Topcoin UK system, all participants must adhere to the
                  following terms and conditions. These policies are established
                  to maintain an active, accountable, and equitable network for
                  all users across the United Kingdom.
                </p>
<strong>
                <ol className="text-dark opacity-75 ">
                  <li className="mt-2 ">
                    Upon registration with Topcoin UK ltd, each customer is
                    required to achieve the second milestone level of twenty-two
                    thousand (22,000) Topcoins within a period of three (3)
                    years from the date of account activation.

                  </li>

                  <li className="mt-2">
                    Failure to reach the specified milestone within the allotted
                    timeframe shall result in the termination and permanent
                    closure of the customer’s Topcoin UK account by Topcoin UK
                    ltd.
                  </li>

                  <li className="mt-2">
                    Once an account has been closed pursuant to this policy, the
                    individual concerned shall not be eligible to create or
                    register another account under the same name,
                    identification, or personal details at any time in the
                    future.
                  </li>

                  <li className="mt-2">
                    There is a limited total supply of thirty million
                    (30,000,000) Topcoins allocated exclusively for the United
                    Kingdom, Scotland, and Wales.
                  </li>
                </ol></strong>
                <p className="info_description text-dark opacity-75 mt-2">
                  No additional Topcoins will be created beyond this limit.
                  Therefore, if a customer does not reach the required milestone
                  of 22,000 Topcoins within the specified period, their account
                  will be closed and their unclaimed Topcoins will be
                  reallocated to another eligible participant to ensure fair
                  distribution and continued circulation within the Topcoin UK
                  system.
                </p>
                <strong>
                <ol className="text-dark opacity-75" start="5">
                  <li className="mt-2">
                    Additional Topcoin allocations for other countries and
                    regions will be announced in future phases of international
                    expansion. The total number of Topcoins available for each
                    country will be formally disclosed by Topcoin UK ltd at the
                    time of release.
                  </li>
                  <li className="mt-2">Purpose of the Milestone Policy</li>
                </ol></strong>

                <br />
                <p className="info_description text-dark opacity-75 mb-0">
                  The milestone requirement of 22,000 Topcoins has been
                  introduced to:
                </p>
<strong>
                <ul className="text-dark opacity-75">
                  <li className="mt-2">
                    Encourage consistent and active participation within the
                    Topcoin UK network.
                  </li>
                  <li className="mt-2">
                    Prevent account inactivity and accumulation of unused
                    Topcoins.
                  </li>
                  <li className="mt-2">
                    Ensure that available Topcoins are circulated among active
                    and genuine users.
                  </li>
                  <li className="mt-2">
                    Maintain system stability, fairness, and long-term
                    sustainability of the Topcoin UK economy.
                  </li>
                </ul></strong>
<br />
<strong>
                <ol className="text-dark opacity-75" start="7">
                  <li className="mt-2">
                     Topcoin UK ltd reserves the right to verify, audit, and
                  enforce compliance with this policy at its sole discretion and
                  to take any necessary action deemed appropriate in accordance
                  with company procedures and applicable UK laws.
                  </li>
                </ol>
</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerRulesAndRegulations;
